import siteConfig from "@app/site-config";
import { DropDownItem, GenerateDropDownItems } from "@shared/classes/general";
import { CsvImportType } from "@shared/enums";

export class SiteConfigHelper {
  public static GetCountryCodeDropDownList() {
    var DropDownItems: DropDownItem[] = [];
    for (var item in siteConfig.CountryCodeMapping) {
      DropDownItems.push({ value: item, label: siteConfig.CountryCodeMapping[item] });
    }

    return DropDownItems;
  }

  public static GetCsvImportMapping(type: CsvImportType) {
    switch (type) {
      case CsvImportType.IT_TOOLS_USAGE:
        return siteConfig.ITToolsUsageImportMapping;

      case CsvImportType.DRIVING_BEHAVIOR:
        return siteConfig.DrivingBehaviorImportMapping;

      case CsvImportType.KPI_ECONOMY:
        return siteConfig.EconomyImportMapping;

      case CsvImportType.ACHIEVEMENT:
        return siteConfig.AchievementImportMapping;

      case CsvImportType.AWARD:
        return siteConfig.AwardImportMapping;

      default:
        return [];
    }
  }

  public static GetDefaultPageSize() {
    return siteConfig.DefaultPageSize;
  }

  public static GetKpiCategoryIdMapping() {
    return siteConfig.KpiCategoryIdMapping;
  }

  public static GetKpiPointPositiveValueIdList() {
    return siteConfig.KpiPointPositiveValueIdList;
  }

  public static GetEDLJobDropDownList() {
    return GenerateDropDownItems(siteConfig.EDLJobs);
  }

  public static IsOccurrenceTargetEditableKPIs(kpi: string) {
    return siteConfig.OccurrenceTargetEditableKPIs.includes(kpi);
  }
}
